import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useActualites from "./hooks/useActualites";

import ActualitesHeader from "./components/ActualitesHeader";
import ActualitesStats from "./components/ActualitesStats";
import ActualitesTable from "./components/ActualitesTable";
import NewsFormDrawer from "./components/NewsFormDrawer";

const Actualites = ({ sectionId }) => {
  const {
    finalSectionId,
    rows,
    stats,
    loading,
    saving,
    demoMode,

    searchTerm,
    setSearchTerm,
    statusFilter,
    setStatusFilter,

    drawer,
    openCreateDrawer,
    openEditDrawer,
    closeDrawer,

    fetchNews,
    handleCreate,
    handleUpdate,
    handleDelete,
  } = useActualites(sectionId);

  return (
    <section className="w-full pb-10 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5">
        <ActualitesHeader
          loading={loading}
          demoMode={demoMode}
          sectionId={finalSectionId}
          onRefresh={fetchNews}
          onCreate={openCreateDrawer}
        />

        <ActualitesStats stats={stats} />

        <ActualitesTable
          rows={rows}
          loading={loading}
          searchTerm={searchTerm}
          statusFilter={statusFilter}
          onSearchChange={setSearchTerm}
          onStatusFilterChange={setStatusFilter}
          onEdit={openEditDrawer}
          onDelete={handleDelete}
        />
      </div>

      <NewsFormDrawer
        isOpen={drawer.type === "create"}
        mode="create"
        sectionId={finalSectionId}
        saving={saving}
        onClose={closeDrawer}
        onCreate={handleCreate}
      />

      <NewsFormDrawer
        isOpen={drawer.type === "edit"}
        mode="edit"
        article={drawer.article}
        sectionId={finalSectionId}
        saving={saving}
        onClose={closeDrawer}
        onUpdate={handleUpdate}
      />

      <ToastContainer position="top-right" autoClose={2500} theme="colored" />
    </section>
  );
};

export default Actualites;